module.exports = __webpack_public_path__ + "assets/img/description.b49df658.png";